<template>
  <ul>
    <li v-for="(item, index) in comments" :key="index" class="mb-4">
      <div
        class="
          px-3
          py-4
          shadow-drop
          rounded-lg
          flex
          items-center
          justify-between
          cursor-not-allowed
        "
        :class="
          item.user_id == $store.state.AppActiveUser.id ? 'bg-grey' : 'bg-white'
        "
      >
        <div>
          <div class="activity-desc">
            <div class="mb-1">
              <feather-icon icon="UserIcon" svg-classes="w-5 h-5" />
              {{ item.user_owner }}
            </div>
            <div>
              <p>{{ item.comment ? item.comment : '' }}</p>
            </div>
          </div>
          <div class="font-semibold text-primary text-left text-sm">
            Créé le {{ item.created_at }}
          </div>
          <div class="mt-4" v-if="item.files.length > 0">
            <!-- <vs-chip
              v-for="(attachment, index) in item.files"
              :key="index"
              color="grey"
              class="cursor-pointer"
            >
              <vs-avatar icon="cloud_download" />
              {{ attachment.filename }}
            </vs-chip> -->

            <div
              v-for="(attachment, index) in item.files"
              :key="index"
              @click.stop="openinnewwindows(attachment.url)"
            >
              <vs-chip color="grey" class="cursor-pointer">
                <vs-avatar icon="cloud_download" />
                {{ attachment.filename }}
              </vs-chip>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "comments",
  components: {},
  props: {
    comments: {
      type: Array,
    },
    settings: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    openinnewwindows(url) {
      window.open(url, "_blank");
    },
    downloadFile(name, url) {
      this.$vs.loading();
      this.$http({
        url: "/comments/file",
        method: "POST",
        responseType: "blob",
        data: {
          name: name,
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", name);
          document.body.appendChild(link);
          link.click();

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
  },
};
</script>

<style>
</style>
